/**
 * /pwa（quietShell）与 Tawk 显隐同步。
 * 脚本由 App 在 load 后空闲静默预载（scheduleTawkSilentPreload）；
 * 路由侧只同步 quietShell，不在每次导航重复注入。
 */

/**
 * @param {{ meta?: { quietShell?: boolean }, path?: string }} route
 */
export function syncTawkVisibilityForRoute(route) {
  if (typeof window === 'undefined') return;
  const quietShell = Boolean(route?.meta?.quietShell);
  const sync = window.dsTawkSyncForAppRoute;
  if (typeof sync === 'function') {
    sync({ quietShell });
    return;
  }
  // index.html 钩子未就绪时的最小兜底
  try {
    const api = window.Tawk_API;
    if (quietShell && api && typeof api.hideWidget === 'function') {
      api.hideWidget();
    }
  } catch {
    /* ignore */
  }
}
